export const menuTitle = { title: "MODUL", label: "Modul" }
  